<template>
    <div class="container">
        <Header :navActive='getNavActive' :navId="activeId"></Header>
        <main class="main-container">
            <slot name="main"></slot>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>

import Header from '@/views/Header';
import Footer from '@/views/Footer';

export default {
    name: 'Layout',
    components: {
        Header,
        Footer,
    },
    props: {
        title: String,
        navActive: String,
        navId: [Number, String],
    },
    data() {
        return {
            getNavActive: this.$props.navActive || window.localStorage.getItem('ZBHA_NAV_ACTIVE'),
            activeId: 0,
        };
    },
    watch: {
        navActive() {
            this.getNavActive = this.$props.navActive || window.localStorage.getItem('ZBHA_NAV_ACTIVE');
        },
        navId() {
            this.activeId = this.$props.navId || 0;
        },
    },
    methods: {
    },
};
</script>
<style lang="less" scoped>
.main-container{
    width: auto;
    padding-top: 70px;
    min-width: 1200px;
}
</style>
